window._ = require('lodash');

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import './authed/authed';
import './un-authed/unauthed';
